/*
 * @Author: oujinfa oujinfa@100efly.com
 * @Date: 2024-04-29 13:13:50
 * @LastEditors: oujinfa oujinfa@100efly.com
 * @LastEditTime: 2024-04-29 14:52:42
 * @FilePath: /oem-pc/src/components/base/Footer/index.tsx
 * @Description: footer components
 */
import style from './index.module.scss'
import recordLogo from '@/static/bingo/image/record_logo.png'

export default function Footer() {
	return (
		<footer className={style.footerContainer}>
			<div className={style.boxAuto}>
				<div className={style.left}>
					<div className={style.stepH}>
						<a className={style.linkA} target="_blank" href="https://www.101efly.com/server.html">
							服务条款
						</a>
						<span className={style.line}>|</span>
						<a className={style.linkA} target="_blank" href="https://www.101efly.com/private.html">
							隐私保护
						</a>
					</div>
					<div className={style.comP}>
						<a className={style.link} href="https://beian.miit.gov.cn/">
							粤ICP备2023109578号
						</a>
						<span className={style.comLine}>|</span>
						<img src={recordLogo} className={style.recordLogo} />
						<a className={style.link} href="https://beian.miit.gov.cn/">
							教育部备案号：教APP备4402325号
						</a>
						<span className={style.comLine}>|</span>
						易辅来（广州）科技有限公司
					</div>
				</div>
			</div>
		</footer>
	)
}
